import { t } from 'i18next';

export const getEmptyErrorMessage = (label?: string) =>
  t('errorFieldCannotBeEmpty', {
    field: label,
  });
